

































































import VueOptions from '@utils/VueOptions'
import EventInfoForCard from '@ui/cards/EventInfoForCard'

settings =
  name: "EventFeedCard"
  vue:
    props: ['item', 'rowSize', 'actions', 'selected', 'backgroundColor', 'options']
    components: { EventInfoForCard }
    computed:
      host: -> @ctxHost(@item)

      instanceEvents: -> @ctxEventInstances(@item)
      instanceEventsCount: -> @instanceEvents.length - 1
      hasOnlyOneInstance: -> (@instanceEvents.length - 1) is 0

      typeIsProductSampling: -> @selectedSpace?.type is 'product_sampling'
      typeIsLiveStream: -> @selectedSpace?.type is 'native_integration'
      typeIsSocialPost: -> @selectedSpace?.type is 'social_media_post'

      hasPhysicalInventory: ->
        x = false
        (x ||= !space.digital) for name, space of @item.spaces
        x
      hasDigitalInventory: ->
        x = false
        (x ||= space.digital) for name, space of @item.spaces
        x
      hasLiveStreamSpace: ->
        x = false
        (x ||= space.type is 'native_integration') for name, space of @item.spaces
        x

      selectedSpace: ->
        space = null
        for k,v of @item.spaces
          space ||= v if v.type is @selectedSpaceType
        space
      selectedSpaceType: -> @options.selectedSpaceType

      quantityForCartItem: ->
        if 'product_sampling' is @selectedSpaceType
          return @selectedSpace.min_quantity
        return 1

      priceForSpace: ->
        (@selectedSpace?.supplier_price_in_cents / 100) || 0

      quantityForSpace: ->
        return @selectedSpace?.min_quantity if @typeIsProductSampling
        1

      canRequestMoreInfo: ->
        return true if @item.can_request_for_more_info
        if @item.live_stream
          return true if @priceForSpace is 0 or @item.virtual.reach is 0
        return true if @item.physical_event and @item.reach is 0

export default VueOptions.vue settings
